export default class UserSpec {
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  org_uuid: string | null;
  uuid: string | null;

  constructor(
    email: string | null = null,
    first_name: string | null = null,
    last_name: string | null = null,
    org_uuid: string | null = null,
    uuid: string | null = null
  ) {
    this.email = email;
    this.first_name = first_name;
    this.last_name = last_name;
    this.org_uuid = org_uuid;
    this.uuid = uuid;
  }
}
